import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import { AnexoType } from "types/anexo/AnexoType";

interface GetAnexosVinculadosAoProcessoProps {
  processoJudicialId: number;
  isVisualizacao: boolean;
}
export const useGetAnexosVinculadosAoProcesso = (props: GetAnexosVinculadosAoProcessoProps) => {
  const { setAnexos } = useProcessosJudiciaisContext();

  const onSuccess = (response: AnexoType[]) => {
    setAnexos(response);
  };

  const onError = () => {
    toast.error("Erro ao buscar anexos vinculados ao processo");
  };

  return useFetch<AnexoType[]>({
    key: [`anexos-processo-isVisualizacao-${props.isVisualizacao}`, props.processoJudicialId],
    url: api.processosJudiciaisAnexos.getAnexosVinculadosAoProcesso,
    enabled: props.processoJudicialId !== undefined,
    pathVariables: props.processoJudicialId?.toString(),
    onSuccess,
    onError,
  });
};
